import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEmployeePayableAmountApi } from "../../apiservice/hrpayroll";
import moment from "moment";

export const fetchMonthlySalaryReport = createAsyncThunk(
  "monthlySalaryReport/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const { filterType, typeId, employee, year, month, attendanceDate } =
        filters;
      const payload = {
        selectedFilterType: 'All',
        typeId: typeId || null,
        employeeId: employee?.employee_id || null,
        year: year || null,
        month: month || null,
        attendanceDate: attendanceDate || null,
        fromDate: moment(
          moment(`${month || ""} ${year || ""}`)
            .startOf("month")
            .format("YYYY-MM-DD")
        )
          .startOf("day")
          .toISOString(),
        toDate: moment(
          moment(`${month || ""} ${year || ""}`)
            .endOf("month")
            .format("YYYY-MM-DD")
        )
          .endOf("day")
          .toISOString(),
      };
      const res = await getEmployeePayableAmountApi(payload);

      const mapped = res.data.map((row, idx) => ({
        id: row.employee_id || idx,
        name: row.employee_name,
        department: row.department_name,
        designation: row.designation_name,
        salary: row.salary || 0,
        attendance: row.precent_days || 0,
        leave_with_pay: row.leave_with_pay_days || 0,
        deduction: row.deduction_salary || 0,
        conveyance: row.conveyance || 0,
        ma: row.ma || 0,
        ta: row.ta || 0,
        da: row.da || 0,
        others_commission: row.commission || 0,
        sales_commission: row.sales_commission || 0,
        sales_amount: row.sold_amount || 0,
        commission_percent: row.commission_per || 0,
        flight_ticket: row.flight_ticket_reimbursement || 0,
        paid: row.monthly_payment_paid || row.paid_amount || 0,
        payable: row.payable_salary || 0,
      }));

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
